import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment/moment';
import OrderStatusDisplayFactory from '../OrderStatusFactory/OrderStatusDisplayFactory';
import OrderPaymentDisplayFactory from '../OrderPaymentFactory/OrderPaymentDisplayFactory';
import CrmOrder from '../../../../classes/CrmOrder';

function OrdersListRow({ order, onRowClick }) {
  const memoizedStatus = useMemo(() => order
    .statusType, [order.shipmentList, order.shippingTimestamp]);
  const memoizedPayment = useMemo(() => order.paymentType,
    [order.shippingStatus, order.shippingTimestamp, order.paymentStatus]);
  return (
    <tr onClick={onRowClick} style={{ cursor: 'pointer' }}>
      <td>
        {
        moment.unix(order.createdAt).format('MMM DD, YYYY')
      }
      </td>
      <td>{order.orderNumber}</td>
      <td>
        {order.grandTotalDisplay}

      </td>
      <td>
        <OrderStatusDisplayFactory
          orderStatusType={memoizedStatus}
          shipDate={order.shippingTimestamp}
        />
      </td>
      <td>{order.poDisplayNumber}</td>
      <td>
        <OrderPaymentDisplayFactory
          orderPaymentStatusType={memoizedPayment}
        />
      </td>
    </tr>
  );
}

OrdersListRow.propTypes = {
  order: PropTypes.shape(CrmOrder).isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default OrdersListRow;
